// export function formatNumber(num) {
//   if (isNaN(num)) {
//     return "- ";
//   }
//   return parseFloat(num.toFixed(1)).toString();
// }
export function formatNumber(value) {
  // coerce to a JS number
  const n = typeof value === "number" ? value : parseFloat(value);

  // if that failed, bail out
  if (!isFinite(n)) {
    return "—";
  }

  // if it's an integer, just return it; otherwise round to one decimal
  return n % 1 === 0 ? n.toString() : n.toFixed(1);
}

export function formatNumber1Dec(num) {
  const n = typeof num === "number" ? num : parseFloat(num);
  if (isNaN(n)) return "";
  if (Math.floor(n) === n) return n.toString();
  return parseFloat(n.toFixed(1)).toString();
}

export function formatNumber2Dec(num) {
  const n = typeof num === "number" ? num : parseFloat(num);
  if (isNaN(n)) return "";
  if (Math.floor(n) === n) return n.toString();
  return parseFloat(n.toFixed(2)).toString();
}

export const audioFormatTime = (timeInSeconds) => {
  if (isNaN(timeInSeconds) || timeInSeconds < 0) return "0:00"; // Handle invalid values
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export function formatTarget(num) {
  if (num === null) {
    // console.log("formatTarget called with:", num, "returning null");
    return null;
  }

  if (typeof num === "string") {
    // console.log("formatTarget called with:", num, "returning", num);
    return num;
  }

  const n = typeof num === "number" ? num : parseFloat(num);
  if (isNaN(n) || n === 0) {
    // console.log("formatTarget called with:", num, "returning null");
    return null;
  }

  // console.log("formatTarget called with:", num, "returning", formatNumber(n));
  return formatNumber2Dec(n);
}
